import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import useStyles from './styles';
import getIntoNested from '../../../getIntoNested';
import {
  inputDataCustom,
  treeStructureSettingsCustom,
} from '../../../../../../../utils/custom_prop_types/customPropTypes';

export default function NestedAccessory({
  nestedProduct,
  fetchProductsBySection,
  inputData,
  addedProducts,
  treeStructureSettings,
  setTreeStructureSettings,
  setOpenModal,
  accessories,
  cornerPostAccessories,
}) {
  const classes = useStyles();

  return (
    <TableCell
      className={classes.nestedProduct}
      data-iri={nestedProduct['@id']}
      data-description={nestedProduct.description}
      data-value={nestedProduct.association}
      onClick={() => getIntoNested({
        nestedProduct,
        addedProducts,
        inputData,
        fetchProductsBySection,
        treeStructureSettings,
        setTreeStructureSettings,
        setOpenModal,
        accessories,
        cornerPostAccessories,
      })}
    >
      {nestedProduct.description}
    </TableCell>
  );
}

NestedAccessory.propTypes = {
  nestedProduct: PropTypes.objectOf(PropTypes.any).isRequired,
  fetchProductsBySection: PropTypes.func.isRequired,
  inputData: inputDataCustom.isRequired,
  addedProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  treeStructureSettings: treeStructureSettingsCustom.isRequired,
  setTreeStructureSettings: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  accessories: PropTypes.objectOf(PropTypes.any).isRequired,
  cornerPostAccessories: PropTypes.objectOf(PropTypes.any).isRequired,
};
